import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  list: (entity, params = {}) => client.get(`/${entity}`, { params }).then((r) => r.data),
  create: (entity, data) => client.post(`/${entity}`, data).then((r) => r.data),
  update: (entity, id, data) => client.put(`/${entity}/${id}`, data).then((r) => r.data),
  remove: (entity, id) => client.delete(`/${entity}/${id}`).then((r) => r.data),
  dashboard: () => client.get(`/stats/dashboard`).then((r) => r.data),
  reminders: () => client.get(`/reminders`).then((r) => r.data),
  sendReminders: () => client.post(`/reminders/send`).then((r) => r.data),
  kanbanConfig: () => client.get(`/kanban/config`).then((r) => r.data),
  kanbanMove: (task_id, to_status, role) => client.post(`/kanban/move`, { task_id, to_status, role }).then((r) => r.data),
  summary: (screen, role, lang) => client.post(`/summary`, { screen, role, lang }).then((r) => r.data),
  login: (email) => client.post(`/auth/login`, { email }).then((r) => r.data),
};

export default api;
